import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import { formInputValidation } from '../../../../../../services/helper/form-helper';
import {
    editState,
    updateEditStatePayload
} from '../../../../../../services/redux/employee/state/actions';
import { 
    fetchFundFilingTypes, 
    fetchRenewalCycleTypes, 
    fetchPaymentTypes, 
    fetchPermitNumberTypes 
} from '../../../../../../services/redux/commonData/actions';
import EditStateForm from "../../components/StateForm";
import Panel from "../../../../../../components/angle/Panel";

class EditState extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }
    componentDidMount() {
        let { 
            fetchFundFilingTypes,
            fetchRenewalCycleTypes,
            fetchPaymentTypes,
            fetchPermitNumberTypes
        } = this.props;
        fetchFundFilingTypes();
        fetchRenewalCycleTypes();
        fetchPaymentTypes();
        fetchPermitNumberTypes();
    }
    onSaveClick = () => {
        let { stateData, history, editState } = this.props;
        let payload = stateData.editStateData;
        if (formInputValidation(this.formRef.current)) {
            editState(payload).then(response => {
                if (response.status === 200) {
                    history.push('/manage-states');
                }
            });
        }
    };

    onCancelClick = () => {
        let { history } = this.props;
        history.push('/manage-states');
    };

    render() {
        let {
            stateData,
            commonData,
            updateEditStatePayload
        } = this.props;

        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [saveButton, cancelButton];

        return (
            <div className="col-md-6 mb" style={{padding: 0}}>
                <Panel
                    showHeader
                    header="Edit State"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div>
                        <EditStateForm
                            stateData={stateData.editStateData}
                            updateStateData={updateEditStatePayload}
                            fundFilingTypes={commonData.fundFilingTypes}
                            renewalCycleTypes={commonData.renewalCycleTypes}
                            paymentTypes={commonData.paymentTypes}
                            permitNumberTypes={commonData.permitNumberTypes}
                            formRef={this.formRef}
                        />
                    </div>
                </Panel>

                {stateData.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    stateData: state.employee.state,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            editState,
            updateEditStatePayload,
            fetchFundFilingTypes,
            fetchRenewalCycleTypes,
            fetchPaymentTypes,
            fetchPermitNumberTypes
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditState));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ManageStates/screens/EditState/index.js